import React, { useCallback, useEffect, useState } from "react";
import { Modal } from "../../common/Modal/Modal";
import {
  LabelStyled,
  PrimaryButton,
  SecondaryButton,
  StyledInput,
} from "../../common/common.style";
import { useDispatch, useSelector } from "react-redux";
import { selectToken, setAddToken } from "../../../store/slices/global";
import toast from "react-hot-toast";
import { Box, FlexBox } from "../../primitives";
import { Wrapper } from "./modalAddCtToken.styled";

interface ModalAddPurchasePriceProps {
  setIsOpenAddTokenModal: (arg1: boolean) => void;
}

export const ModalAddCtToken = ({
  setIsOpenAddTokenModal,
}: ModalAddPurchasePriceProps) => {
  const token = useSelector(selectToken);
  const [localToken, setLocalToken] = useState(token);
  const dispatch = useDispatch();

  const onAddTokenHandler = useCallback(async () => {
    setIsOpenAddTokenModal(false);
    dispatch(setAddToken(localToken));
    toast.success("TOKEN ADDED SUCCESSFULLY");
  }, [dispatch, localToken, setIsOpenAddTokenModal]);

  const commonFunctionOnCancel = useCallback(() => {
    setIsOpenAddTokenModal(false);
  }, [setIsOpenAddTokenModal]);

  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        commonFunctionOnCancel();
      } else if (e.key === "Enter") {
        onAddTokenHandler();
      }
    };

    window.addEventListener("keydown", handleEscape);
    return () => window.removeEventListener("keydown", handleEscape);
  }, [
    commonFunctionOnCancel,
    dispatch,
    onAddTokenHandler,
    setIsOpenAddTokenModal,
  ]);

  return (
    <Modal onClose={() => commonFunctionOnCancel()}>
      <Wrapper>
        <LabelStyled>ADD YOU CT TOKEN</LabelStyled>
        <Box css={{ textAlign: "center" }}>
          The CardTrader token is required to price cards and publish them on
          their marketplace.
        </Box>
        <StyledInput
          type="text"
          value={localToken}
          onChange={(e) => {
            setLocalToken(e.target.value);
          }}
          css={{ width: "80%", marginTop: 10 }}
        />

        <FlexBox css={{ gap: 10, justifyContent: "center" }}>
          <PrimaryButton
            onClick={() => {
              onAddTokenHandler();
            }}
          >
            CONFIRM
          </PrimaryButton>
          <SecondaryButton onClick={commonFunctionOnCancel}>
            <Box>Cancel</Box>
            <Box>( ESC )</Box>
          </SecondaryButton>
        </FlexBox>
      </Wrapper>
    </Modal>
  );
};
